module.exports = __webpack_public_path__ + "img/taoyuan-map.13641b20.png";